import React from 'react';
import ManagerLayout from '../../../mimic/manager/ManagerLayout';
import Card from '../../../mimic/shared/Card';

const ManagerLeaseScene = () => {
  return (
    <ManagerLayout>
      <Card>
        <h2>Manager Lease Overview</h2>
        <p>This is a placeholder for the lease workflow.</p>
      </Card>
    </ManagerLayout>
  );
};

export default ManagerLeaseScene;
